import { noTagPage, getById } from '@/api/business/ship'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(noTagPage, getById)
